/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TableExpansionTemplate } from 'src/app/@amiga-pyme/table-expansion/templates/table-expansion.template';
import { CartSaleService } from './cart-sale.service';

@Component({
  selector: 'pg-cart-sale',
  templateUrl: './cart-sale.component.html',
  providers: [MessageService]
})
export class CartSaleComponent extends TableExpansionTemplate {
  @Output() items = new EventEmitter<any>();
  openSideBar = false;
  openConfirmRemove = false;
  itemToRemoveCart = null;
  itemToSideBar: any;
  amountSale = null;

  constructor(
    private messageService: MessageService,
    private cartSaleService: CartSaleService
  ) {
    super('', null);
  }

  ngOnInit(): void {
    this.table.settings = {
      title: 'Productos del Carrito',
      columns: [
        { header: 'Código', field: 'productCode' },
        { header: 'Nombre', field: 'productName' },
        { header: 'Concentración', field: 'productRegulatedConcentration' },
        {
          header: 'Tipo de Presentación',
          field: 'productRegulatedPresentation'
        },
        { header: 'Laboratorio', field: 'productRegulatedLaboratory' },
        { header: 'Expiración', field: 'expAt' },
        { header: 'Lote', field: 'lot' }
      ],
      child: {
        columnPatent: {
          title: 'productName',
          data: 'formatsSelled'
        }
      }
    };
    this.tableChild.settings = {
      title: '',
      columns: [
        { header: 'F.V.', field: 'format' },
        { header: 'S.F.V', field: 'subFormat' },
        { header: 'Cnt.S.F.V', field: 'quantitySubFormat' },
        { header: 'Stock', field: 'stock' },
        { header: 'En carrito', field: 'quantityInCart' },
        { header: 'P.V.', field: 'precio', pipe: 'Currency' }
      ],
      filterColumns: false,
      exportData: false
    };

    this.tableChild.actions = [
      {
        name: 'update-product-cart-sale',
        icon: 'pi pi-pencil',
        class: 'p-button-rounded p-button-success mr-2',
        pTooltip: 'Actualizar Producto'
      },
      {
        name: 'remove-product-cart-sale',
        icon: 'pi pi-trash',
        class: 'p-button-rounded p-button-warning mr-2',
        pTooltip: 'Remover Producto'
      }
    ];
    this.cartSaleService.getData$().subscribe((data) => {
      this.table.data = data;
      this.amountSale = this.cartSaleService.getTotalAmount()
        ? this.cartSaleService.getTotalAmount()
        : 0;
    });
  }

  onReciveActionChild(event: any): void {
    if (event.action === 'update-product-cart-sale') {
      this.itemToSideBar = event.data;
      this.openSideBar = true;
    } else if (event.action === 'remove-product-cart-sale') {
      this.openConfirmRemove = true;
      this.itemToRemoveCart = event.data;
    }
  }

  removeItemCart() {
    this.cartSaleService.removeItem(this.itemToRemoveCart);
    this.messageService.add({
      severity: 'success',
      summary: 'Producto Removido',
      detail: 'Producto Removido Satisfactoriamente del Carrito'
    });
    this.openConfirmRemove = false;
    this.itemToRemoveCart = null;
  }

  onOpenItemsCart() {
    this.open = true;
  }

  isCartEmpty() {
    return this.cartSaleService.isCartEmpty();
  }
}
